import { MenuItem, Select } from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';
import {
  fetchShopifyInventory,
  updateOrderByParam,
} from '@src/reducers/shopify';
import { OrderByParam } from '@src/reducers/shopify/types';
import { getOrderByParam } from '@src/selectors/shopify';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

const MenuItemStyled = withStyles((theme: Theme) => ({
  root: {
    color: theme.palette.text.primary,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '140%',
    padding: '8px 10px',
    margin: '2px',
    borderRadius: '8px',
    '&:hover': {
      color: theme.palette.common.white,
      backgroundColor: '#4C33FF',
    },
  },
  selected: {
    color: theme.palette.common.white,
    '&.MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover': {
      borderRadius: '8px',
      backgroundColor: '#4C33FF',
    },
  },
}))(MenuItem);

const SelectStyled = withStyles({
  select: {
    padding: '8px 10px',
    borderRadius: '8px 8px 0px 0px',
    margin: '2px',
    '&.MuiSelect-select:focus': {
      borderRadius: '8px',
    },
  },
})(Select);

const OrderByWrapper: React.FC = () => {
  const dispatch = useDispatch();
  const orderByParam = useSelector(getOrderByParam);
  const handleUpdateOrderBy = (value: OrderByParam) => {
    dispatch(updateOrderByParam(value));
  };

  useEffect(() => {
    dispatch(fetchShopifyInventory());
  }, [dispatch, orderByParam]);
  return (
    <OrderBy
      orderByParam={orderByParam}
      handleUpdateOrderBy={handleUpdateOrderBy}
    />
  );
};

interface IOrderBy {
  orderByParam: OrderByParam;
  handleUpdateOrderBy: (value: OrderByParam) => void;
}

export const OrderBy: React.FC<IOrderBy> = ({
  orderByParam,
  handleUpdateOrderBy,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;

  return (
    <SelectStyled
      onChange={(event: React.ChangeEvent<{ value: unknown }>) =>
        handleUpdateOrderBy(event.target.value as OrderByParam)
      }
      displayEmpty
      value={orderByParam}
      style={{ height: '32px', width: '100%' }}
      MenuProps={{
        PaperProps: {
          style: {
            marginTop: '34px',
          },
        },
      }}
    >
      <MenuItemStyled value="TITLE">
        {formatMessage({ id: 'Shopify.OrderBy.Options.Alfabetic' })}
      </MenuItemStyled>
      <MenuItemStyled value="CREATED_AT&reverse">
        {formatMessage({ id: 'Shopify.OrderBy.Options.CreationDate.Desc' })}
      </MenuItemStyled>
      <MenuItemStyled value="CREATED_AT">
        {formatMessage({ id: 'Shopify.OrderBy.Options.CreationDate.Asc' })}
      </MenuItemStyled>
    </SelectStyled>
  );
};

export default OrderByWrapper;
